/*!
 * Floppy, uses Dexie (V. 3.0.1), A Minimalistic Wrapper for IndexedDB
 * Authors: ['Jorge Brunal Perez (aka Diniremix)', 'Duverney Ortiz']
 * Version: 2020-07-01
 * https://git.sitimapa.co/serviforms/serviforms-admin
 * Released under the MIT License.
 */

import Dexie from "dexie";

const databasename = "data_rutas_database_V1";
const version = 1;

const db = new Dexie(databasename);

const createStores = () => {
	db.version(version).stores({
		users: "&,access_token,added_on,additional_info,code_recover_date,code_recover_pass,company_id,company_name,created_at,email,expire_token,id,identification,lastname,name,permissions,role_id,role_name,status,status_id,typology_id,typology_name,uid,update_on,username", //ID unique
		upload_files: "&,upload_type,object_type,url_file,bucket_path,original_name,typology_id,public,id,role_id",
		map_config: "&,optionsProgramedRoute,optionsExecutedRoute",
		app_setting: "&,color",
		preferences: "&",
	});

	db.open().catch(function (e) {
		console.error("========================================================");
		console.error("IndexedDB cannot be used in this browser!.");
		console.error("Floppy cannot use IndexedDB.");
		console.error("More information at: https://caniuse.com/#feat=indexeddb");
		console.error("IndexedDB", e.name, e.message);
		console.error("========================================================");
	});
};

createStores();

export default {
	init() {
		//createStores();
	},

	open() {
		db.open();
	},

	close() {
		db.close();
	},

	isOpen() {
		return db.isOpen();
	},

	getAll(table) {
		const myTable = db.table(table);
		return myTable.toArray();
	},

	getKey(table, key) {
		const myTable = db.table(table);
		return myTable.get(key);
	},

	save(table, data, key) {
		const myTable = db.table(table);
		return myTable.add(data, key);
	},

	put(table, data, key) {
		const myTable = db.table(table);
		return myTable.put(data, key);
	},

	update(table, data, key) {
		const myTable = db.table(table);
		return myTable.update(key, data);
	},

	deleteKey(table, key) {
		const myTable = db.table(table);
		return myTable.delete(key);
	},

	each(table) {
		const myTable = db.table(table);

		return new Promise((resolve, reject) => {
			var _list = [];

			myTable
				.each((item) => {
					_list.push(item);
				})
				.then(() => {
					resolve(_list);
				})
				.catch(function (error) {
					reject(error.stack || error);
				});
		});
	},

	count(table) {
		const myTable = db.table(table);
		return myTable.count();
	},

	first(table, key) {
		const myTable = db.table(table);
		return myTable.toCollection().first();
	},

	last(table, key) {
		const myTable = db.table(table);
		return myTable.toCollection().last();
	},

	getTableInstance(table) {
		const myTable = db.table(table);
		return new Promise((resolve, reject) => {
			if (myTable) {
				resolve(myTable);
			} else {
				reject(myTable);
			}
		});
	},

	// async function getDBInstance(){
	getDBInstance() {
		return new Promise((resolve, reject) => {
			if (db.isOpen()) {
				resolve(db);
			} else {
				reject("DatabaseClosedError: Database has been closed");
			}
		});
	},

	schema() {
		return new Promise((resolve, reject) => {
			if (db.isOpen()) {
				var currentSchema = db.tables.map(({name, schema}) => ({name, schema}));
				resolve(currentSchema);
			} else {
				reject("DatabaseClosedError: Database has been closed");
			}
		});
	},

	truncate(table, confirm) {
		const myTable = db.table(table);
		return myTable.clear();
	},

	//Giovanni Rosas
	giovanni(dbname) {
		db.close();
		// db.delete()
		console.warn("Giovanni Rosas has deleted the database!: ¯\\_(ツ)_/¯");
		return Dexie.delete(dbname);
	},

	deleteDB(dbname, confirm) {
		return new Promise((resolve, reject) => {
			if (confirm !== null && confirm !== undefined) {
				if (confirm === "Yes!") {
					db.close();
					// db.delete()
					resolve(Dexie.delete(dbname));
				}
				reject("DatabaseError: the database cannot be deleted, the order must be: Yes!");
			}
			reject("DatabaseError: the database cannot be deleted, confirm your order first!");
		});
	},

	dbname() {
		return db.name;
	},

	version() {
		return db.verno;
	},

	//do not use, very unstable method
	where_(table, field, key) {
		const myTable = db.table(table);
		myTable
			.where(field)
			.equals(key)
			.first()
			.then((r) => console.log(r))
			.catch((error) => console.warn(error));
	},
};
